import { $element } from "@grindex-common/helpers/elements";

function init() {
	const $blogArchiveSelect = $element("blog-archive");

	const createEventListeners = () => {
		if ($blogArchiveSelect) {
			$blogArchiveSelect.addEventListener("change", function (ev) {
				if (ev.target.selectedIndex !== 0) {
					window.location = ev.target.selectedOptions[0].value;
				}
			});
		}
	};

	createEventListeners();
}

export default {
	view: "blogArchive",
	init,
};
